import SelectSort from './SelectSort';

export default SelectSort;
